operations:
  load-models: Tải các mô hình
  load-models-status:
    loading: Đang tải
    ready: Sẵn sàng
docs:
  theme:
    navbar:
      appearance:
        title: Giao diện
'controls-island':
  'fade-on-hover':
    enable: Ẩn khi rê chuột
    disable: Luôn hiển thị
  'chat-bubble':
    enable: Hiển thị bong bóng trò chuyện
    disable: Ẩn bong bóng trò chuyện
  'open-settings': Mở cài đặt
  'open-chat': Mở trò chuyện
  'refresh': Làm mới
  'open-hearing-controls': Kiểm soát thính giác mở
  'drag-to-move-window': Kéo để di chuyển cửa sổ
  'switch-to-light-mode': Chuyển sang chế độ sáng
  'switch-to-dark-mode': Chuyển sang chế độ tối
  'pin-on-top': Ghim lên trên
  'unpin-from-top': Gỡ ghim khỏi đầu trang
  'switch-profile': Switch Profile
  'close': Đóng
  'expand': Mở rộng
  'collapse': Sụp đổ
  'login': Sign in
  'logging-in': Signing in...
  'account': Account
  'logout': Sign out
widgets:
  close: Close widget
  empty:
    title: No widget active
    description: Widgets will appear here when a tool or plugin spawns one.
  loading: Loading widget…
  waiting: Waiting for widget data for "{id}"…
notice:
  'fade-on-hover':
    title: Mờ dần khi rê chuột
    intro: Tự làm mờ nhân vật khi con trỏ ở gần. Giảm xao nhãng nhưng vẫn nhìn thấy nhân vật.
    opacity: Bật lên thì độ mờ giảm xuống {value} cho {targets} khi con trỏ ở gần.
    toggle: Tắt đi bằng cách rê chuột qua {controls} rồi bấm lại {icon}.
    controls-label: Đảo Điều Khiển
    icon-label: biểu tượng mắt gạch
    value: '0'
    targets: Nhân vật và giao diện
    confirm: Đã hiểu
    dont-show-again: Đừng hiển thị lại
    preparing: Đang chuẩn bị…
    read-more: Xem thêm
    preview-title: Đây là gì?
about:
  subtitle: Desktop ver.
  current-version: Current Version
  common:
    cancel: Cancel
  links:
    title: Links
    home: Home
    documentation: Documentations
    github: GitHub
  update:
    lane:
      label: Update lane
      description: Choose channel release to follow
      placeholder: Choose update lane
    channels:
      auto: Auto
      stable: Stable
      alpha: Alpha
      beta: Beta
      nightly: Nightly
      canary: Canary
    status:
      downloading: Downloading update...
      error-prefix: Error
      latest: Up to date (v{version}).
      downloaded:
        windows: Update ready to install silently (v{version}).
        restart: Update ready to install on restart (v{version}).
    actions:
      download: Download Update
      download-short: Download
      confirm-download: Confirm Download
      check-for-updates: Check for updates
      checking: Checking...
      latest-version: Latest version
      disabled-dev: Updates disabled in Dev
      retry-check: Retry Check
      restart-silent: Restart to update silently
      restart-install: Restart to install update
      confirm-restart: Confirm Restart
    dialog:
      title: Update Available
      description: A new version (v{version}) is available.
      no-release-notes-markdown: _No release notes provided._
